import Vue from 'vue';

import Ripple from 'vue-ripple-directive';
import { VBToggle } from 'bootstrap-vue';

Vue.directive('ripple', Ripple);
Vue.directive('b-toggle', VBToggle);
